import { SlideComponentPronunciationAssessment } from '@/types/slide';
import { SlideComponentCreator } from './factory';

export class SlideComponentPronunciationAssessmentCreator extends SlideComponentCreator {
    public create(id: string): SlideComponentPronunciationAssessment {
        return {
            id: id,
            type: 'pronunciationAssessment',
            pos: {
                x: 0,
                y: 0,
            },
            size: { width: 214, height: 168 },
            content: {
                refText: '',
            },
        };
    }
}
